export default "__VITE_ASSET__9e5e7351__"